import type { Entity } from '@models/Entity'

import { apiClient } from '../../../gateways/api'
import type { AccountOption } from '../types/AccountOption'

export { fetchContactpersoonAccounts, initialState, MIN_QUERY_SIZE }

async function fetchContactpersoonAccounts({
  entity: { id, type },
  text,
}: {
  entity: Entity
  text: string
}): Promise<AccountOption[]> {
  if (text.trim().length < MIN_QUERY_SIZE) return initialState.data

  const { data } = await apiClient({
    url: `/rest/${type}/${id}/contactpersoon/accounts`,
    method: 'GET',
    params: { text: text.trim() },
  })

  return data
}

const MIN_QUERY_SIZE = 4

const initialState: { data: AccountOption[] } = {
  data: [],
}
